var React = require('react');

function IconBoltFilled (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"bolt-filled"},React.createElement("path",{"id":"vector","d":"M14.8943 2.07292C15.0107 1.75905 14.884 1.40703 14.5944 1.23919C14.3048 1.07135 13.9364 1.13649 13.7219 1.39346L4.55523 12.3751C4.38422 12.58 4.34721 12.8653 4.4603 13.107C4.5734 13.3487 4.81615 13.5031 5.08302 13.5031H10.5085L8.10576 19.9265C7.98849 20.24 8.11405 20.5924 8.40314 20.7611C8.69222 20.9298 9.06081 20.8658 9.2761 20.6095L18.4428 9.69685C18.6147 9.49221 18.6524 9.20651 18.5395 8.96427C18.4266 8.72203 18.1836 8.56715 17.9163 8.56715H12.4877L14.8943 2.07292Z","fill":"currentColor"})));
}

IconBoltFilled.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 23 22","fill":"none"};

module.exports = IconBoltFilled;

IconBoltFilled.default = IconBoltFilled;
